<template>
  <section >
    <div class="customerReviews" v-if="isPC">
        <div class="rate f-b">
            <div class="left f" v-if="reviewList.length">
                <div class="totalScore">
                    <h2 style="margin-bottom: 14px">{{$t('productDetail.customerReviews')}}</h2>
                    <div style="margin-bottom: 14px">
                        <el-rate
                            v-model="rateObj.averageStar"
                            disabled
                            text-color="#FDD52E"
                            score-template="{value}">
                        </el-rate>
                    </div>
                    <h2 style="padding-left: 4px">{{rateObj.averageStar}}</h2>
                </div>
                <!-- progress样式由样式穿透控制 -->
                <div class="progress">
                    <div class="progress_item f">
                        <div class="starBox">
                            <i class="el-icon el-icon-star-on"></i>5
                        </div>
                        <el-progress :percentage="rateObj.fiveStarPercent" :stroke-width="6" color="#FFC32A"></el-progress>
                    </div>
                    <div class="progress_item f">
                        <div class="starBox">
                            <i class="el-icon el-icon-star-on"></i>4
                        </div>
                        <el-progress :percentage="rateObj.fourStarPercent" :stroke-width="6" color="#FFC32A"></el-progress>
                    </div>
                    <div class="progress_item f">
                        <div class="starBox">
                            <i class="el-icon el-icon-star-on"></i>3
                        </div>
                        <el-progress :percentage="rateObj.threeStarPercent" :stroke-width="6" color="#FFC32A"></el-progress>
                    </div>
                    <div class="progress_item f">
                        <div class="starBox">
                            <i class="el-icon el-icon-star-on"></i>2
                        </div>
                        <el-progress :percentage="rateObj.twoStarPercent" :stroke-width="6" color="#FFC32A"></el-progress>
                    </div>
                    <div class="progress_item f">
                        <div class="starBox">
                            <i class="el-icon el-icon-star-on"></i>1
                        </div>
                        <el-progress :percentage="rateObj.oneStarPercent" :stroke-width="6" color="#FFC32A"></el-progress>
                    </div>
                </div>
            </div>
            <div class="left f--c" v-else>
                <div>
                    <h3 style="margin-bottom: 16px">{{ $t('commodity.Components.CustomerReviews.NoReviewsYet') }}</h3>
                    <p>{{ $t('commodity.Components.CustomerReviews.Tips1') }}</p>
                </div>
            </div>
            <div class="right f--c">
                <el-button round @click="wtireReview">{{$t('productDetail.writeAReview')}}</el-button>
            </div>
        </div>
        <div class="reviewList">
            <div class="reviewList_item f-b" v-for="item in reviewList" :key="item.id">
                <div class="content f">
                    <div class="content_rate">
                        <el-rate
                            v-model="item.star"
                            disabled
                            text-color="#FDD52E"
                            score-template="{value}">
                        </el-rate>
                        <div style="margin-top:10px">{{item.userName}}</div>
                    </div>
                    <div class="content_font">
                        <div style="margin-bottom: 10px">
                            {{ $t('commodity.Components.CustomerReviews.Color') }}: <span style="color: #747A87;margin-right: 10px">{{item.color}}</span>
                            {{ $t('commodity.Components.CustomerReviews.Size') }}: <span style="color: #747A87">{{item.size}}</span>
                        </div>
                        <div class="content_font_review">{{item.review}}</div>
                    </div>
                </div>
                <div class="date">{{item.createDate | dateFormat}}</div>
            </div>
        </div>
        <div class="viewMore f-c" v-if="total > reviewList.length">
            <el-button round @click="searchProductGetProductReviewList">{{ $t('commodity.Components.CustomerReviews.ViewMore') }} <i class="el-icon-arrow-down"></i></el-button>
        </div>
        <el-drawer
            :title="$t('commodity.Components.CustomerReviews.WriteAReview')"
            :before-close="handleClose"
            :visible.sync="addVisible"
            direction="rtl"
            custom-class="demo-drawer"
            ref="drawer"
            :size="700"
            >
            <div class="drawer__content">
                <div class="f drawer__content_rate">
                    <div class="image" style="margin-right: 28px;width:100px;height:150px">
                        <oss-img :width="50" :height="75" :src="colorImg"></oss-img>
                    </div>
                    <div>
                        <h4 style="margin-bottom: 26px">{{ $t('commodity.Components.CustomerReviews.Tips2') }}</h4>
                        <el-rate v-model="addForm.star" style="font-size: 30px"></el-rate>
                    </div>
                </div>
                <el-form :model="addForm" :rules="addRules" :hide-required-asterisk="true" ref="addForm">
                    <el-form-item :label="$t('commodity.Components.CustomerReviews.Color')" label-width="80px" prop="color">
                        <el-select v-model="addForm.color" :placeholder="$t('commodity.Components.CustomerReviews.Select')" style="width:100%" @change="colorChange">
                            <el-option :label="item.color" :value="item.color" v-for="item in colorList" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('commodity.Components.CustomerReviews.Size')" label-width="80px" prop="size">
                        <el-select v-model="addForm.size" :placeholder="$t('commodity.Components.CustomerReviews.Select')" style="width:100%">
                            <el-option :label="item.size" :value="item.size" v-for="item in sizeList" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('commodity.Components.CustomerReviews.Review')" label-width="80px" prop="review">
                        <el-input
                            type="textarea"
                            :placeholder="$t('commodity.Components.CustomerReviews.Tips3')"
                            v-model="addForm.review"
                            resize="none"
                            :rows="4"
                        />
                    </el-form-item>
                    <el-form-item :label="$t('commodity.Components.CustomerReviews.Name')" label-width="80px" prop="userName">
                        <el-input
                            :placeholder="$t('commodity.Components.CustomerReviews.YourName')"
                            v-model="addForm.userName"
                        />
                    </el-form-item>
                    <el-form-item :label="$t('commodity.Components.CustomerReviews.Email')" label-width="80px" prop="email">
                        <el-input v-model="addForm.email" :placeholder="$t('commodity.Components.CustomerReviews.YourEmailAddress')"></el-input>
                    </el-form-item>
                </el-form>
                <div class="demo-drawer__footer f-c">
                    <el-button type="primary" @click="searchProductProductReviewAdd" :loading="submitLoading" style="width:360px;">{{ $t('commodity.Components.CustomerReviews.SubmitReview') }}</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
    <div class="customerReviews customerReviews_mt" v-else>
        <div class="rate">
            <div class="left " v-if="reviewList.length">
                <div class="totalScore f">
                    <!-- <h2 style="margin-bottom: 14px">{{$t('productDetail.customerReviews')}}</h2> -->
                    <div style="margin-bottom: 14px">
                        <el-rate
                            v-model="rateObj.averageStar"
                            disabled
                            text-color="#FDD52E"
                            score-template="{value}">
                        </el-rate>
                    </div>
                    <h2 style="padding-left: 4px">{{rateObj.averageStar}}</h2>
                </div>
                <!-- progress样式由样式穿透控制 -->
                <div class="progress">
                    <div class="progress_item f--c">
                        <div class="starBox">
                            <i class="el-icon el-icon-star-on"></i>5
                        </div>
                        <el-progress :percentage="rateObj.fiveStarPercent" :stroke-width="6" color="#FFC32A"></el-progress>
                    </div>
                    <div class="progress_item f--c">
                        <div class="starBox">
                            <i class="el-icon el-icon-star-on"></i>4
                        </div>
                        <el-progress :percentage="rateObj.fourStarPercent" :stroke-width="6" color="#FFC32A"></el-progress>
                    </div>
                    <div class="progress_item f--c">
                        <div class="starBox">
                            <i class="el-icon el-icon-star-on"></i>3
                        </div>
                        <el-progress :percentage="rateObj.threeStarPercent" :stroke-width="6" color="#FFC32A"></el-progress>
                    </div>
                    <div class="progress_item f--c">
                        <div class="starBox">
                            <i class="el-icon el-icon-star-on"></i>2
                        </div>
                        <el-progress :percentage="rateObj.twoStarPercent" :stroke-width="6" color="#FFC32A"></el-progress>
                    </div>
                    <div class="progress_item f--c">
                        <div class="starBox">
                            <i class="el-icon el-icon-star-on"></i>1
                        </div>
                        <el-progress :percentage="rateObj.oneStarPercent" :stroke-width="6" color="#FFC32A"></el-progress>
                    </div>
                </div>
            </div>
            <div class="left f-c-c" v-else>
                <div>
                    <h3 style="margin-bottom: 16px;text-align: center;">{{ $t('commodity.Components.CustomerReviews.NoReviewsYet') }}</h3>
                    <p>{{ $t('commodity.Components.CustomerReviews.Tips1') }}</p>
                </div>
            </div>
            <div class="right f-c-c">
                <el-button round @click="wtireReview">{{$t('productDetail.writeAReview')}}</el-button>
            </div>
        </div>
        <div class="reviewList">
            <div class="reviewList_item " v-for="item in reviewList" :key="item.id">
                <div class="content f-b" style="width:100%">
                    <div class="content_rate" >
                        <el-rate
                            v-model="item.star"
                            disabled
                            text-color="#FDD52E"
                            score-template="{value}">
                        </el-rate>
                    </div>
                    <div class="date">{{item.createDate | dateFormat}}</div>
                </div>
                <div class="f">
                  <div style="margin-right:.1rem">{{item.userName}}</div>
                  <div style="margin-right:.1rem">{{ $t('commodity.Components.CustomerReviews.Color') }}:{{item.color}}</div>
                  <div>{{ $t('commodity.Components.CustomerReviews.Size') }}:{{item.size}}</div>
                </div>
                <div class="content_font_review">{{item.review}}</div>
            </div>
        </div>
        <div class="viewMore f-c" v-if="total > reviewList.length">
            <el-button round @click="searchProductGetProductReviewList">{{ $t('commodity.Components.CustomerReviews.ViewMore') }} <i class="el-icon-arrow-down"></i></el-button>
        </div>
        <el-drawer
            :before-close="handleClose"
            :visible.sync="addVisible"
            direction="rtl"
            ref="drawer"
            size="100%"
            :show-close="false"
            :modal="false"
            custom-class="drawer_MT"
            >
            <div class="drawer__content_MT">
              <div class="topRouter bg-white" style="margin-bottom:.2rem">
                <span @click="addVisible = false">
                  <i class="el-icon-arrow-left"></i>
                  {{ $t('commodity.Components.CustomerReviews.WriteAReview') }}
                </span>
              </div>
                <div class="f drawer__content_rate bg-white" style="margin-bottom: .2rem;padding: .1rem .2rem;">
                    <div class="image" style="margin-right: .2rem;width:100px;height:150px;">
                        <oss-img :width="50" :height="75" :src="colorImg" style="display:block;border-radius: 6px;"></oss-img>
                    </div>
                    <div>
                        <h4 style="margin-bottom: 26px">{{ $t('commodity.Components.CustomerReviews.Tips2') }}</h4>
                        <el-rate v-model="addForm.star" style="font-size: .6rem"></el-rate>
                    </div>
                </div>
                <div>
                  <div class="bg-white" style="margin: .1rem 0">
                    <BigSelect :value="addForm.color" :columns="colorList" :placeholder="$t('commodity.Components.CustomerReviews.Color')" :isRequired="true" @change="colorChange" :customField="{label: 'color', value: 'color'}"></BigSelect>
                  </div>
                  <div class="bg-white" style="margin: .1rem 0">
                    <BigSelect :value="addForm.size" :columns="sizeList" :placeholder="$t('commodity.Components.CustomerReviews.Size')" :isRequired="true" :customField="{label: 'size', value: 'size'}"></BigSelect>
                  </div>
                  <div style="margin: .1rem 0">
                    <el-input
                        type="textarea"
                        :placeholder="$t('commodity.Components.CustomerReviews.Tips3')"
                        v-model="addForm.review"
                        resize="none"
                        :rows="4"
                        style="border:none"
                    />
                  </div>
                  <div style="margin: .1rem 0">
                    <el-input
                        placeholder="Your name"
                        v-model="addForm.userName"
                        class="bigInput"
                    />
                  </div>
                  <div style="margin: .1rem 0">
                    <el-input v-model="addForm.email" :placeholder="$t('commodity.Components.CustomerReviews.YourEmailAddress')" class="bigInput"></el-input>
                  </div>
                </div>
                <!-- <el-form :model="addForm" :rules="addRules" :hide-required-asterisk="true" ref="addForm">
                    <el-form-item label="" prop="color">
                      <div class="bg-white">
                        <BigSelect :value="addForm.color" :columns="colorList" :placeholder="'color'" :isRequired="true" @change="colorChange" :customField="{label: 'color', value: 'color'}"></BigSelect>
                      </div>
                    </el-form-item>
                    <el-form-item label="" prop="size">
                      <div class="bg-white">
                        <BigSelect :value="addForm.size" :columns="sizeList" :placeholder="'size'" :isRequired="true" :customField="{label: 'size', value: 'size'}"></BigSelect>
                      </div>
                    </el-form-item>
                    <el-form-item label="" prop="review">
                        <el-input
                            type="textarea"
                            placeholder="Write a short review"
                            v-model="addForm.review"
                            resize="none"
                            :rows="4"
                            style="border:none"
                        />
                    </el-form-item>
                    <el-form-item label="" prop="userName">
                        <el-input
                            placeholder="Your name"
                            v-model="addForm.userName"
                            class="bigInput"
                        />
                    </el-form-item>
                    <el-form-item label=""  prop="email">
                        <el-input v-model="addForm.email" placeholder="Your email address" class="bigInput"></el-input>
                    </el-form-item>
                </el-form> -->
                <div class="demo-drawer__footer f-c">
                    <el-button type="primary" @click="searchProductProductReviewAdd" :loading="submitLoading" style="width:360px;">{{ $t('commodity.Components.CustomerReviews.SubmitReview') }}</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
  </section>
</template>

<script>
import API from '@/api'
import { checkEmail } from '@/util/validate'
import dayjs from 'dayjs'
import BigSelect from '@/components/mobile/BigSelect.vue'
export default {
  props: {
    sizeList: {
      type: Array,
      default: () => []
    },
    colorList: {
      type: Array,
      default: () => []
    },
    kkProductId: [String, Number],
    color: {
      type: String,
      default: () => ''
    },
    size: {
      type: String,
      default: () => ''
    }
  },
  filters: {
    dateFormat(value) {
      return dayjs(value).format('YYYY-MM-DD')
    }
  },
  components: {
    BigSelect
  },
  data() {
    let valiEmailPss = (rule, value, callback) => {
      if (checkEmail(value)) {
        callback()
      } else {
        callback(new Error('Please enter your vaild email'))
      }
    }
    return {
      value: 0,
      params: {
        pageNumber: 1,
        pageSize: 5
      },
      reviewList: [],
      total: 0,
      rateObj: {
        averageStar: 0,
        fiveStarPercent: 0,
        fourStarPercent: 0,
        oneStarPercent: 0,
        threeStarPercent: 0,
        twoStarPercent: 0
      },
      info: {
        color: undefined,
        size: undefined,
        kkProductId: undefined
      },
      addVisible: false,
      addForm: {
        color: undefined,
        review: undefined,
        size: undefined,
        star: 1,
        userName: undefined,
        email: undefined
      },
      submitLoading: false,
      addRules: {
        color: [{ required: true, trigger: 'change' }],
        size: [{ required: true, trigger: 'change' }],
        review: [{ required: true, trigger: 'blur' }],
        userName: [{ required: true, trigger: 'blur' }],
        email: [{ validator: valiEmailPss, trigger: ['blur', 'change'] }]
      },
      colorImg: undefined
    }
  },
  computed: {
    userId() {
      return this.$store.state.common.userId
    }
  },
  methods: {
    searchProductGetProductReviewList() {
      const params = { ...this.params, ...this.info, kkProductId: this.kkProductId }
      delete params.color
      delete params.size
      API.searchProductGetProductReviewList(params).then(res => {
        this.reviewList = [...this.reviewList, ...res.data.list]
        this.total = res.data.total
        this.$emit('total', this.total)
        this.params.pageNumber++
      })
    },
    searchProductGetProductReviewStarPercent() {
      const params = { ...this.info, kkProductId: this.kkProductId }
      delete params.color
      delete params.size
      API.searchProductGetProductReviewStarPercent(params).then(res => {
        this.rateObj = res.data
      })
    },
    getData() {
      this.searchProductGetProductReviewList()
      this.searchProductGetProductReviewStarPercent()
    },
    setValue(info) {
      this.info = info
      this.$nextTick(() => {
        this.getData()
      })
    },
    handleClose() {
      this.addVisible = false
    },
    searchProductProductReviewAdd() {
      if (this.isPC) {
        this.$refs.addForm.validate((valid) => {
          if (!valid) return
          const params = { ...this.addForm, kkProductId: this.kkProductId }
          if (!params.star) return this.$message.error(this.$t('promptText.msg24'))
          this.submitLoading = true
          API.searchProductProductReviewAdd(params).then(res => {
            this.$message.success(res.message)
            this.submitSuccess()
          }).catch(err => {
            this.$message.error(err.data.message)
          }).finally(() => {
            this.submitLoading = false
          })
        })
      } else {
        const params = { ...this.addForm, kkProductId: this.kkProductId }
        if (!params.star) return this.$message.error(this.$t('promptText.msg24'))
        this.submitLoading = true
        API.searchProductProductReviewAdd(params).then(res => {
          this.$message.success(res.message)
          this.submitSuccess()
        }).catch(err => {
          this.$message.error(err.data.message)
        }).finally(() => {
          this.submitLoading = false
        })
      }
    },
    submitSuccess() {
      Object.keys(this.addForm).forEach(key => {
        this.addForm[key] = undefined
      })
      this.isPC && this.$refs.addForm.resetFields()
      this.addForm.star = 1
      this.addVisible = false
      this.params.pageNumber = 1
      this.reviewList = []
      this.getData()
    },
    colorChange(value) {
      const target = this.colorList.find(e => e.color === value)
      this.colorImg = target.colorImg
    },
    wtireReview() {
      if (!this.isLogin()) return
      this.addForm.color = this.color
      this.colorChange(this.addForm.color)
      this.addForm.size = this.size
      const { userName, email } = this.$store.state.common
      if (userName) {
        this.addForm.userName = userName
        this.addForm.email = email
      }
      this.addVisible = true
      this.$record({
        eventType: 'click',
        eventId: `${this.$route.meta.pageId}_writeAReview_click`,
        value: JSON.stringify({ kkProductId: this.kkProductId })
      })
    },
    isLogin() {
      if (!this.userId) {
        localStorage.setItem('loginRedirection', JSON.stringify({
          path: this.$route.path,
          query: this.$route.query
        }))
        this.$store.dispatch('logOut')
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.customerReviews{
    width: 100%;
    .rate {
        margin: 20px 0;
        // height: 200px;
        background-color: #F5F7F7;
        padding: 28px 40px;
        margin-bottom: 20px;
        .left{
            .totalScore {
                margin-right: 70px;
                /deep/.el-rate__icon{
                    font-size: 26px;
                }
            }
            .progress{
                .progress_item{
                    margin-bottom: 14px;
                    /deep/.el-progress{
                        width: 300px;
                    }
                    /deep/.el-progress__text{
                        display: inline-block !important;
                    }
                    .starBox {
                      margin-right: 14px;
                      font-size: 16px;
                    }
                }
                .el-icon-star-on{
                    color: #FDD52E;
                }
                /deep/.el-progress-bar__outer{
                    background-color: #E7E8E8 !important;
                    height: 10px !important;
                }
            }
        }
        .right{

        }
    }
    .reviewList {
        margin-bottom: 40px;
        .reviewList_item{
            border-bottom: 1px solid #CDD4DD;
            padding-bottom: 24px;
            margin-bottom: 10px;
            .content{
                .content_rate{
                    margin-right: 250px;
                    /deep/.el-icon-star-on{
                        font-size: 26px;
                    }
                }
                .content_font_review {
                  width: 650px;
                  word-break: break-all;
                  font-size: 14px;
                  line-height: 20px;
                }
            }
            .date{
              color: #8B93A3;
            }
        }
    }
    .viewMore {
        width: 100%;
    }
    .drawer__content {
        width: 440px;
        margin: 0 auto;
        .drawer__content_rate {
            margin-bottom:50px;
            /deep/.el-rate__icon{
                font-size: 50px;
            }
        }
    }
    .drawer__content_MT {
        width: 100%;
        margin: 0 auto;
        background-color: #F5F7F7;
        .drawer__content_rate {
            margin-bottom:50px;
            /deep/.el-rate__icon{
                font-size: .7rem;
            }
        }
        /deep/.el-form-item{
          margin-bottom: .4rem !important;
        }
    }
    /deep/.drawer_MT{
      box-shadow: 0 !important;
      background-color: #F5F7F7;
      /deep/#el-drawer__title{
        display: none !important;
      }
    }
    /deep/.el-textarea{
      textarea{
        border: none;
      }
    }
    .bigInput{
      /deep/.el-input__inner{
        border-radius: 0 !important;
        border: none !important;
      }
    }
}
.customerReviews_mt{
  /deep/.el-drawer__wrapper{
    top: .86rem !important;
  }
  .rate{
    padding: .1rem;
    /deep/.el-progress--line{
      width: 80% !important;
    }
    /deep/.starBox{
      font-size: .4rem !important;
    }
    .progress_item{
      margin: 0 !important;
    }
  }
  .content_rate{
    margin-right: 0 !important;
    /deep/.el-rate__icon{
      font-size: .4rem !important;
    }
  }
}
</style>
<style lang="scss">
  .drawer_MT{
      #el-drawer__title{
        display: none !important;
      }
    }
</style>
